import { BrowserRouter as Router } from "react-router-dom";
import React from "react";
import { Provider } from "react-redux";
import App from "../containers/App";
import Modal from "../components/Modal";
import store from "../redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ConfigProvider } from "antd";

export default () => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: "#386df6",
      },
    }}
  >
    <Provider store={store}>
      <Router>
        <App />
        <Modal />
      </Router>
      <ToastContainer />
    </Provider>
  </ConfigProvider>
);
